import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';
import {MatTooltip} from '@angular/material/tooltip';
import {MatInput} from '@angular/material/input';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { ColorPickerDirective } from 'ngx-color-picker';
import { MatIcon } from '@angular/material/icon';
import { LineDashArrayViewComponent } from '../line-type-item/line-dash-array-view.component';
import { LineTypeSelectorComponent } from '../line-type-selector/line-type-selector.component';
import { LineStyle } from '../../models/styling';

@Component({
  selector: 'app-line-style-editor',
  templateUrl: './line-style-editor.component.html',
  imports: [
    MatFormField,
    FormsModule,
    MatTooltip,
    MatInput,
    MatLabel,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    ColorPickerDirective,
    MatButton,
    MatIcon,
    LineDashArrayViewComponent,
    LineTypeSelectorComponent,
  ],
  styleUrls: ['./line-style-editor.component.scss', '../../../../styles/forms.scss'],
})
export class LineStyleEditorComponent implements OnInit {
  @Input() editWidth = true;
  @Input() editOpacity = true;
  @Input() routeStyle: LineStyle;
  @Input() defaultStyle: LineStyle;
  @Output() routeStyleChanged: EventEmitter<LineStyle> = new EventEmitter<LineStyle>();

  style: LineStyle;

  constructor() {}

  ngOnInit() {
    this.style = this.routeStyle ?? new LineStyle();
  }

  styleChanged() {
    this.routeStyleChanged.emit(this.style);
  }

  clearColor() {
    this.style.color = undefined;
    if (!this.style.width && !this.style.opacity && !this.style.lineType) {
      this.routeStyleChanged.emit(null);
    } else {
      this.routeStyleChanged.emit(this.style);
    }
  }

  clearWidth() {
    this.style.width = undefined;
    if (!this.style.color && !this.style.opacity && !this.style.lineType) {
      this.routeStyleChanged.emit(null);
    } else {
      this.routeStyleChanged.emit(this.style);
    }
  }

  clearOpacity() {
    this.style.opacity = undefined;
    if (!this.style.color && !this.style.width && !this.style.lineType) {
      this.routeStyleChanged.emit(null);
    } else {
      this.routeStyleChanged.emit(this.style);
    }
  }

  clearDashArray() {
    this.style.lineType = undefined;
    if (!this.style.width && !this.style.opacity && !this.style.color) {
      this.routeStyleChanged.emit(null);
    } else {
      this.routeStyleChanged.emit(this.style);
    }
  }
}
